import registrationApi from 'api/rest/registration'
import styles from '../../main-nav-bar/mainNavBar.module.scss'
import UserApi from 'api/rest/user'
import { getOwnProfileUrl } from 'utils'
import {
  MY_ACCOUNT_HREF,
  MY_DETAILS_HREF,
  PRIVACY_AND_CONSENTS_HREF,
  SIGN_IN_DETAILS_HREF,
  WATCHLISTS_HREF,
} from 'constants/global'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

export const SignIn = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <button
      onClick={() => {
        registrationApi.redirectToSignIn({ enableLogging: true })
      }}
      className={cx(styles.btn, styles.signInLinkDesktop, className)}
    >
      {t('button.signIn')}
    </button>
  )
}

export const SignOut = () => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <button
      onClick={() => {
        UserApi.signOut()
      }}
      className={styles.navLink}
    >
      {t('button.signOut')}
    </button>
  )
}

export const MyProfile = () => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <a href={getOwnProfileUrl()} className={styles.navLink}>
      {t('link.myProfile')}
    </a>
  )
}

export const MyDetails = () => {
  const { t } = useTranslation(['strMyAccount'])
  return (
    <a href={MY_DETAILS_HREF} className={styles.navLink}>
      {t('myDetails')}
    </a>
  )
}

export const SignInDetails = () => {
  const { t } = useTranslation(['strMyAccount'])
  return (
    <a href={SIGN_IN_DETAILS_HREF} className={styles.navLink}>
      {t('signInDetails.title')}
    </a>
  )
}

export const PrivacyAndConsents = () => {
  const { t } = useTranslation(['strMyAccount'])
  return (
    <a href={PRIVACY_AND_CONSENTS_HREF} className={styles.navLink}>
      {t('privacyAndConsents.title')}
    </a>
  )
}

export const MyAccount = () => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <a href={MY_ACCOUNT_HREF} className={styles.navLink}>
      {t('link.myAccount')}
    </a>
  )
}

export const MyWatchlists = () => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <a href={WATCHLISTS_HREF} className={styles.navLink}>
      {t('link.myWatchlists')}
    </a>
  )
}
